<script lang="ts">
import { defineComponent, PropType, inject } from 'vue'
import StepWrapper from './StepWrapper.vue'

export default defineComponent({
  name: 'IndustryStep',

  components: {
    StepWrapper,
  },

  props: {
    namespace: {
      type: String,
      required: true,
    },

    industry: {
      type: Object as PropType<InputText>,
      required: true,
    },
  },

  emits: ['update:industry', 'click:prev', 'click:next'],

  setup(_, { emit }) {
    const INDUSTRIES = inject<string[]>('INDUSTRIES')!

    const next = () => {
      emit('click:next')
    }

    return {
      // constants
      INDUSTRIES,

      // methods
      next,
    }
  },
})
</script>

<template>
  <StepWrapper
    :namespace="namespace"
    :input-scheme="industry"
    category-label="業種"
    :category-items="INDUSTRIES"
    @update:model-value="$emit('update:industry', $event)"
    @click:prev="$emit('click:prev')"
    @click:next="$emit('click:next')" />
</template>
